import React from "react";
import gbFlag from "@/components/icons/flags/gb.svg";
import auFlag from "@/components/icons/flags/au.svg";
import chFlag from "@/components/icons/flags/ch.svg";
import caFlag from "@/components/icons/flags/ca.svg";
import inFlag from "@/components/icons/flags/in.svg";

// Square country flags for the Stock Center warehouses. The SVGs are vendored
// (kapowaz/square-flags) into icons/flags/ so they're self-hosted — no external
// runtime dependency, works offline. Warehouse code → ISO 3166-1 alpha-2 file.
// Warehouse code → flag image URL. Exported so callers can use a flag as a
// decorative CSS background (e.g. the faded masthead flag in StockCenterPage).
export const FLAG_SRC = {
  UK: gbFlag,   // United Kingdom → gb
  AUS: auFlag,  // Australia → au
  CH: chFlag,   // Switzerland → ch
  CA: caFlag,   // Canada → ca
  IN: inFlag,   // India → in
};

export default function WarehouseFlag({ code, className = "", size = 18 }) {
  const src = FLAG_SRC[code];
  if (!src) {
    return (
      <span
        className={`inline-flex items-center justify-center rounded-[3px] bg-[hsl(var(--muted))] text-[9px] font-mono-data text-[hsl(var(--muted-foreground))] ${className}`}
        style={{ width: size, height: size }}
      >
        {(code || "?").slice(0, 2)}
      </span>
    );
  }
  return (
    <img
      src={src}
      alt={`${code} flag`}
      width={size}
      height={size}
      className={`inline-block rounded-[3px] object-cover ${className}`}
      style={{ width: size, height: size, boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.12)" }}
      draggable={false}
    />
  );
}

// Globe glyph for the "All warehouses" tab.
export function AllWarehousesGlyph({ className = "" }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <circle cx="12" cy="12" r="9" /><path d="M3 12h18" /><path d="M12 3a14 14 0 0 1 0 18a14 14 0 0 1 0-18" />
    </svg>
  );
}
